import { fmtDate, StatusBadge, s } from "./ExternalTimeline";

export default function ReadOnlyList({ project, tasks }) {
  return (
    <div style={s.card}>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            {["Project", "Assignee", "Status", "Start", "End", "Notes"].map(h => (
              <th key={h} style={s.tableHead}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ ...s.tableCell, fontWeight: 700 }}>{project.name}</td>
            <td style={s.tableCell}>{project.assignee_name || "—"}</td>
            <td style={s.tableCell}><StatusBadge status={project.status} /></td>
            <td style={s.tableCell}>{fmtDate(project.start_date)}</td>
            <td style={s.tableCell}>{fmtDate(project.end_date)}</td>
            <td style={s.tableCell}>{project.notes || "—"}</td>
          </tr>
        </tbody>
      </table>

      {tasks.length > 0 && (
        <>
          <div style={{ marginTop: 20, marginBottom: 10, fontSize: 11, fontWeight: 700, color: "var(--khv-text-secondary)", letterSpacing: "0.06em", textTransform: "uppercase" }}>
            Tasks
          </div>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                {["Task", "Status", "Start", "End", "Notes"].map(h => (
                  <th key={h} style={s.tableHead}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tasks.map(task => (
                <tr key={task.id}>
                  <td style={{ ...s.tableCell, fontWeight: 600 }}>{task.name}</td>
                  <td style={s.tableCell}><StatusBadge status={task.status} /></td>
                  <td style={s.tableCell}>{fmtDate(task.start_date)}</td>
                  <td style={s.tableCell}>{fmtDate(task.end_date)}</td>
                  <td style={s.tableCell}>{task.notes || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}
